var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAssignee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Assignee",
    "data-name": "Add Assignee",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M356.1,272.836a20,20,0,1,1-20-20,20,20,0,0,1,20,20",
    transform: "translate(-316.102 -252.836)",
    fill: "none",
    stroke: "#475757",
    strokeWidth: 1,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M405.9,330.329H400.52v-5.29a1.3,1.3,0,0,0-2.595,0v5.29h-5.376a1.248,1.248,0,1,0,0,2.494h5.376v5.045a1.3,1.3,0,0,0,2.595,0v-5.045H405.9a1.248,1.248,0,1,0,0-2.494",
    transform: "translate(-378.751 -311.293)",
    fill: "#00246a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAssignee);
export default __webpack_public_path__ + "static/media/Add Assignee.34f19569621396cbcf1486fe89f7ca63.svg";
export { ForwardRef as ReactComponent };